<template>
  <div class="max-w-md mx-auto">
    <div class="p-4 mt-2 text-center">
      <h1 class="mb-0">{{ momentFormat(localDate, 'dddd') }}</h1>
      <p class="m-0 text-sm">{{ $t('general.this_week') }}</p>
    </div>
    <div class="p-4 pt-0 stack-sm" v-if="entries.length > 0">
      <p
        class="text-center tracking-wide mb-2"
      >{{ $t('activities.this_day_you_completed_following_activities') }}:</p>
      <activity v-for="entry in entries" :activity-id="entry.activity_id" :key="entry.id" />
    </div>
    <div class="p-4" v-else>
      {{ $t('activities.no_completed_activities_on_this_date') }}.
      <span
        v-if="localDate.day() > momentDate().day()"
      >{{ $t('activities.future-date') }}.</span>
    </div>
    <div class="p-4 text-center" v-if="localDate.day() > momentDate().day()">
      <wd-button @input="goTo('/activities')">{{ $tc('activities.activity', 2)}}</wd-button>
    </div>
  </div>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";

const Activity = require("@/modules/activities/components/Activity.vue")
  .default;

export default {
  name: "DayActivitiesSite",
  mixins: [DateMixin],
  data() {
    return {
      localDate: null,
      entries: []
    };
  },
  props: {
    date: {
      type: String
    }
  },
  components: {
    Activity
  },
  methods: {},
  computed: {},
  async created() {
    if (this.date) {
      this.localDate = this.momentDate().day(this.date);
    } else {
      this.localDate = this.momentDate();
    }

    let weekEntries = await this.$store.getters[
      "activityentry/api"
    ].Custom.ThisWeek();

    this.entries = weekEntries.filter(e => {
      return this.momentify(e.created_at).isSame(this.localDate, "day");
    });

    this.$store.dispatch("header/update", {
      backbutton: true,
      clear: true,
      elements: [
        {
          value: this.$t("activities.day_activities"),
          css: "tracking-wider font-medium"
        }
      ]
    });

    this.loaded();
  }
};
</script>